import AsyncStorage from '@react-native-async-storage/async-storage';

export const USER_SETTINGS_KEY = 'userSettings';
export const GUEST_USER_SETTINGS_KEY = 'guestUserSettings';

export interface UserSettingsAdapterInterface<T> {
  fetch(): Promise<T | null>;
  remove(): Promise<void>;
  save(settings: T): Promise<void>;
}

export class UserSettingsAdapter<T> implements UserSettingsAdapterInterface<T> {
  constructor(private cacheKey: string) {}

  async fetch(): Promise<T | null> {
    const savedUserSettings = await AsyncStorage.getItem(this.cacheKey);
    return savedUserSettings ? JSON.parse(savedUserSettings) : null;
  }

  async remove(): Promise<void> {
    await AsyncStorage.removeItem(this.cacheKey);
  }

  async save(settings: T): Promise<void> {
    await AsyncStorage.setItem(this.cacheKey, JSON.stringify(settings));
  }
}
